import React from 'react';
import { Apple, Play } from 'lucide-react';

export default function StoreBadges(){return <section className="vd-store-preview"><div><p>Next stop</p><h2>Take the peace with you.</h2><span>Native apps are not live yet—this previews the future download moment.</span></div><div><button disabled><Apple size={24}/><span><small>Coming soon to the</small>App Store</span></button><button disabled><Play size={22}/><span><small>Coming soon to</small>Google Play</span></button></div></section>}

